export default __webpack_public_path__ + "static/media/ArialBlack.974d5d05.ttf";